import React, { ReactNode } from 'react'

interface AccordionHeaderPropTypes {
  children: ReactNode
  className?: string
}
const AccordionHeader: React.FC<AccordionHeaderPropTypes> = ({
  children,
  className = '',
}) => {
  return <div className={`w-full font-primary ${className}`}>{children}</div>
}

export default AccordionHeader
